//const API_URL = "http://localhost:5000/";

const API_URL = "https://talenttrackedu.com/";
// const API_URL = "/";

export default API_URL;
